

<h2 mat-dialog-title *ngIf="!thisObject">Adaugare utilizator nou</h2>
<h2 mat-dialog-title *ngIf="thisObject">Modificare utilizator: <b>{{thisObject.name}}</b></h2>

<mat-dialog-content style="height: auto!important;">
  <ngx-loading [show]="loading" style="z-index: 9999;"></ngx-loading>
  <form [formGroup]="objectForm" style="width: 100%">

    <div [fxFlex]="userProfileContainerWidth" class="p-24">
      <mat-card-title>
        <span> Profil utilizator </span>
      </mat-card-title>

      <form [formGroup]="objectForm" style="max-width: 100%!important;">

        <div fxLayout fxLayoutWrap fxLayoutGap="25px">
          <mat-form-field appearance="standard" fxFlex="100" class="pr-4">
            <mat-label>Nume</mat-label>
            <input matInput formControlName="name">
            <mat-icon matSuffix class="disabled-text">account_circle</mat-icon>
            <mat-error *ngIf="objectForm.get('name').errors?.objectForm">{{ objectForm.get('name').errors?.serverError }}</mat-error>
          </mat-form-field>
        </div>

        <div fxLayout fxLayoutWrap fxLayoutGap="25px">
          <mat-form-field appearance="standard" fxFlex="100" class="pr-4">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email">
            <mat-icon matSuffix class="disabled-text">email_circle</mat-icon>
            <mat-error *ngIf="objectForm.get('email').errors?.serverError">{{ objectForm.get('email').errors?.serverError }}</mat-error>
          </mat-form-field>
        </div>

        <div fxLayout fxLayoutWrap fxLayoutGap="25px">
          <mat-form-field appearance="standard" fxFlex="100" class="pr-4">
            <mat-label>Tip utilizator</mat-label>
            <mat-select formControlName="entityType" style="width: 100%!important;" [(value)]="selectedEntityType" (valueChange)="onEntityTypeChange($event)" [compareWith]="compareObjects">
              <mat-option *ngFor="let item of entityTypeList" [value]="item">{{item}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div fxLayout fxLayoutWrap fxLayoutGap="25px">
          <mat-form-field appearance="standard" fxFlex="100" class="pr-4">
            <mat-label>Parola</mat-label>
            <input matInput type="password" formControlName="password">
            <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
            <mat-error *ngIf="objectForm.get('password').errors?.objectForm">{{ objectForm.get('password').errors?.serverError }}</mat-error>
          </mat-form-field>
        </div>

        <div fxLayout fxLayoutWrap fxLayoutGap="25px">
          <mat-form-field appearance="standard" fxFlex="100" class="pr-4">
            <mat-label>Parola (Confirmare)</mat-label>
            <input matInput type="password" formControlName="password_confirmation">
            <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
            <mat-error *ngIf="objectForm.get('password_confirmation').hasError('required')">
              Confirmarea parolei este obligatorie
            </mat-error>
            <mat-error *ngIf="!objectForm.get('password_confirmation').hasError('required') && objectForm.get('password_confirmation').hasError('passwordsNotMatching')">
              Parola nu este identica cu cea de mai sus
            </mat-error>
            <mat-error *ngIf="objectForm.get('password_confirmation').errors?.serverError">{{ objectForm.get('password_confirmation').errors?.serverError }}</mat-error>
          </mat-form-field>
        </div>

        <div fxLayout fxLayoutWrap fxLayoutGap="25px">
          <div class="checkBoxWrapper pr-4" fxFlex="100">
            <mat-checkbox formControlName="isAdmin" [checked]="false" (change)="onIsAdminChange($event)">Utilizatorul are drept de admin</mat-checkbox>
          </div>
        </div>

        <div fxLayout fxLayoutWrap fxLayoutGap="25px">
          <div class="checkBoxWrapper pr-4" fxFlex="100">
            <mat-checkbox formControlName="isActive" [checked]="false">Utilizator activ</mat-checkbox>
          </div>
        </div>

        <div fxLayout fxLayoutWrap fxLayoutGap="25px" style="margin-top: 15px; margin-left: 10px;">

          <span *ngIf="selectedEntityType === 'student'">
            <button mat-button color="primary" (click)="openCv()" *ngIf="cvUrl"> Deschide CV </button>
            <p *ngIf="!cvUrl">CV: Nu exista CV uploadat pentru acest user.</p>
          </span>

          <span *ngIf="selectedEntityType !== 'student'">
             <button mat-button color="primary" (click)="openDelegationCompanyDocument()" *ngIf="documentUrl"> Deschide dovada delegare companie </button>
            <p *ngIf="!documentUrl">CV: Nu exista document dovada de delogare uploadata pentru acest user.</p>
          </span>
        </div>

      </form>
    </div>

    <div [fxFlex]="userProfileContainerWidth" class="p-24" *ngIf="selectedEntityType !== 'student'">
      <mat-card-title>
        <span> Informatii companie </span>
      </mat-card-title>
      <form [formGroup]="companyForm" style="max-width: 100%!important;">
        <div fxLayout fxLayoutWrap fxLayoutGap="25px">
          <mat-form-field appearance="standard" fxFlex="100">
            <mat-label>Denumire firma</mat-label>
            <input matInput formControlName="name">
            <mat-icon matSuffix class="disabled-text">account_circle</mat-icon>
            <mat-error *ngIf="companyForm.get('name').errors?.serverError">{{ companyForm.get('name').errors?.serverError }}</mat-error>
          </mat-form-field>
        </div>

        <div fxLayout fxLayoutWrap fxLayoutGap="25px">
          <mat-form-field appearance="standard" fxFlex="100" class="pr-4">
            <mat-label>CUI</mat-label>
            <input matInput formControlName="uniqueRegistrationCode">
            <mat-icon matSuffix class="disabled-text">edit_circle</mat-icon>
            <mat-error *ngIf="companyForm.get('uniqueRegistrationCode').errors?.serverError">{{ companyForm.get('uniqueRegistrationCode').errors?.serverError }}</mat-error>
          </mat-form-field>
        </div>

        <div fxLayout fxLayoutWrap fxLayoutGap="25px">
          <mat-form-field appearance="standard" fxFlex="100" class="pr-4">
            <mat-label>Registrul comertului</mat-label>
            <input matInput formControlName="nrRegCom">
            <mat-icon matSuffix class="disabled-text">edit_circle</mat-icon>
            <mat-error *ngIf="companyForm.get('nrRegCom').errors?.serverError">{{ companyForm.get('nrRegCom').errors?.serverError }}</mat-error>
          </mat-form-field>
        </div>
      </form>
    </div>

  </form>

</mat-dialog-content>

<mat-dialog-actions>
  <div class="actions">

    <div class="action-buttons">
      <button class="mat-raised-button" mat-dialog-close (click)="onClickCancel()">Inchide</button>
      <button class="mat-raised-button mat-primary" [disabled]="validateForm()"  (click)="onClickSave()" >Salveaza</button>
    </div>

  </div>
</mat-dialog-actions>

